import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config/api";

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
    setError("");
  };

const handleLogin = async (e) => {
  e.preventDefault();

   console.log("LOGIN CLICKED"); 

  try {
  const res = await fetch(`${API_BASE_URL}/api/login`, {
    
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    });

   

   const text = await res.text();

    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error("Server returned non-JSON:", text);
      setError("Server error");
      return;
    }

    if (!res.ok) {
      setError(data.message || "Login failed");
      return;
    }

    const user = data.user;
    const token = data.authToken;

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("authToken", token);

    // =========================
    // ROUTING LOGIC
    // =========================
    if (user.role === "admin") {
      navigate("/admin/dashboard");
      return;
    }

    // USER FLOW
    const permRes = await fetch(
      `${API_BASE_URL}/api/users/${user.id}/permissions`
    );

    const pages = await permRes.json();

    const firstPage = pages?.[0] || "dashboard";

    navigate(`/user/dashboard`);
  } catch (err) {
    console.error(err);
    setError("Server error. Please try again.");
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">MasterPhone</h1>
          <p className="text-gray-500 text-sm mt-1">Admin & Staff Login</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="text"
            name="username"
            placeholder="Username"
            value={credentials.username}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-400 outline-none"
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={credentials.password}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-indigo-400 outline-none"
            required
          />

          {error && <p className="text-red-500 text-sm text-center">{error}</p>}

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition font-semibold"
          >
            Login
          </button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-6">
          © {new Date().getFullYear()} MasterPhone
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;